import { render, staticRenderFns } from "./LogosSection.vue?vue&type=template&id=021700b3&scoped=true&"
import script from "./LogosSection.vue?vue&type=script&lang=js&"
export * from "./LogosSection.vue?vue&type=script&lang=js&"
import style0 from "./LogosSection.vue?vue&type=style&index=0&id=021700b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021700b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
